export const MAX_SPOTLIGHTS = 3
export const NEWS_REFRESH = 16 * 60 * 60 * 1000 // 16 hours
export const REVIEWS_REFRESH = 24 * 60 * 60 * 1000 // 24 hours
export const REPORTS_REFRESH = 15 * 60 * 1000 // 15 minutes

export const NOTIFICATION_PREVIEW_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000 // dashboard card ignores older unread items
export const NOTIFICATION_PREVIEW_COUNT = 3

export const SCORE_THRESHOLD_HIGH = 80
export const SCORE_THRESHOLD_MEDIUM = 60
export const SCORE_THRESHOLD_LOW = 40

export const LOCATION_STALE_THRESHOLD_MS = 20 * 60 * 1000 // 20 minutes
export const LOCATION_POLL_INTERVAL_MS = 30 * 60 * 1000 // 30 minutes
export const COMMUNITY_MAP_NEARBY_KM = 10 // the Community map's "Nearby" filter radius
export const COMMUNITY_POLL_INTERVAL_MS = 10 * 60 * 1000 // 10 minutes
export const COMMUNITY_POLL_CHECK_MS = 60 * 1000 // how often to check if a refresh is due
export const COMMUNITY_POLL_IDLE_LIMIT_MS = 60 * 60 * 1000 // stop polling after 60 min without mouse or keyboard input
